define('views/savings/savings',[
	'views/_base/baseview',
	'text!views/savings/savings.html',
	'models/accounts/accountsummary_collection',
	'views/savings/saving',
	'views/savings/saving_create_btn',
	'views/savings/manage',
	'views/shared/modal/modal_modern',
], function (
	BaseView,
	Template,
	AccountSummary,
	Saving,
	SavingsButtonView,
	ManageAccountsView,
	Modal
) {
	'use strict';

	return BaseView.extend({
		id: 'savings-container',
		tagName: 'div',
		isRender: true,
		template: _.template(Template),
		events: {
			'click .js-savings-header': 'handleSavingsHeaderClick',
			'click .js-manage-savings-allocations': 'manageAllocations',
			'click .js-savings-preview-next': 'showNextAccounts',
			'click .js-savings-preview-previous': 'showPreviousAccounts',
		},
		initialize: function (options) {
			options = options || {};

			this.elementName = options.elementName;
			this.options = options.options ? options.options : {};

			if (this.options.view == 'savings') {
				this.focused = true;
				this.className = 'focused';
			} else {
				this.focused = false;
			}

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			this.$el.html(this.template());

			pf.savings = this;

			// Temporary fix
			if (this.focused) {
				this.$el.addClass('focused');
			}

			this.toggleFocusedElements();

			return this;
		},

		loadData: function () {
			var that = this;

			pf.controller.loadAccounts(function (spending_account, savings) {
				that.addSavings(pf.accounts.savings);
			});
		},

		handleSavingsHeaderClick: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			pf.navigate('savings');
		},

		getData: function () {
			var that = this;

			pf.controller.loadAccounts(function () {
				that.addSavings(pf.accounts.savings);
			});
		},

		addSavings: function (savings) {
			this.$('#savings-list-container').html('');

			savings.forEach(this.addSaving, this);

			this.addCreateSavingsBtn();

			if (savings.length == 0) {
				this.addEmptyState();
			}

			this.addPadding();

			if (savings.length > 3) {
				this.enableSlider();
			}
		},

		addSaving: function (el) {
			var saving = new Saving({ data: el });
			this.$('#savings-list-container').append(saving.el);
		},

		addCreateSavingsBtn: function () {
			var create_savings_btn = new SavingsButtonView();
			this.$('#savings-list-container').append(create_savings_btn.el);
		},

		addPadding: function () {
			this.$('#savings-list-container').append(
				'<li class="padding">&#160;</li>'
			);
		},

		addEmptyState: function () {
			this.$('#savings-list-container').append(
				'<li class="empty-state"><p>Create accounts to organize and store your cash back.</p></li>'
			);
		},

		toggleFocusedElements: function () {
			if (!this.focused) {
				this.$('.js-savings-allocations').hide();
			} else {
				this.$('.js-savings-allocations').fadeIn();
			}
		},

		manageAllocations: function (e) {
			if (isSunsetting()) {
				e.preventDefault();
				return;
			}
			if (pf.IsConsumerFinancial) {
				var accounts_modal_view = new ManageAccountsView();
				var accounts_modal = new Modal({
					show: true,
					content: accounts_modal_view.$el.html(),
					calling_view: accounts_modal_view,
				});
			} else {
				goToFinancialRegistration('savings');
			}
		},

		enableSlider: function () {
			this.$el.find('.js-savings-preview-next').addClass('show');
		},

		showNextAccounts: function () {
			this.animateList('next');
		},

		showPreviousAccounts: function () {
			this.animateList('previous');
		},

		resetPreview: function () {
			this.$el.find('#savings-list-container').css({ marginLeft: '0px' });
			this.$el.find('.js-savings-preview-previous').removeClass('show');

			if (pf.accounts.savings.length > 3) {
				this.$el.find('.js-savings-preview-next').addClass('show');
			}
		},

		animateList: function (direction) {
			var list = this.$el.find('#savings-list-container'),
				list_container = this.$el.find('#savings-inner-container'),
				next_btn = list_container.find('.js-savings-preview-next'),
				previous_btn = list_container.find('.js-savings-preview-previous'),
				preview_width = list_container.width(),
				list_width =
					(list.children().eq(0).width() + 8) * (list.children().length + 1),
				current_offset = Math.abs(parseInt(list.css('marginLeft'))),
				offset =
					direction == 'next'
						? preview_width + current_offset
						: current_offset - preview_width;

			if (
				(direction == 'next' && offset <= list_width) ||
				(direction == 'previous' && offset >= 0)
			) {
				list.animate({ marginLeft: '-' + offset + 'px' }, this.animate_time);

				if (offset + preview_width > list_width) {
					next_btn.removeClass('show');
				} else if (offset + preview_width <= list_width) {
					next_btn.addClass('show');
				}

				if (offset > 0) {
					previous_btn.addClass('show');
				} else if (offset - preview_width < 0) {
					previous_btn.removeClass('show');
				}
			}
		},

		close: function () {},
	});
});

